import { cooperativeShopSaveItem } from "../prefab/cooperativePrefab/cooperativeConst";
import { kaoguDataType } from "../prefab/kaogu/kaogu/config/kaoguDataHelp";
import { oilfieldDataType } from "../prefab/oilfield/config/oilfieldDataHelp";

/**
 * 数据定义
 */
// TODO 数据定义
export interface NormalModeDataI {
    /** 声望 */
    m_reputation?: number;
    /** 官职等级 */
    m_officialLv?: number;
    plotDialogue?: boolean;//是否开幕开关
    switchVoice?: boolean;//声音开关
    switchVoiceEffect?: boolean;//声音开关
    switchVibration?: boolean;//震动开关
    userHeadArray?: string[];//用户头像 数组
    userCurrHead?: string;//用户当前头像
    userAccountInfoNewMsg?: number;//新消息开关
    userAccountInfo?: AccountItem[];//用户账单
    weChatLinks?: WeChatTriggerTimeLink[]; // 微信聊天的触发线
    eventQueue?: string[];//事件队列
    todayEvent?: string[];//今日事件
    ariseEvent?: string[];//所有出现过的事件  只会记录唯一事件
    /** 所有出现过的聊天线  只会记录唯一的聊天线 */
    ariseLinks?: string[]; // 
    /** 第一次进入界面 */
    firstEnterLayer?: string[];
    /** 随机事件次数 */
    randomEventCount?: number[];
    loanCount?: number;//贷款次数
    gameFail?: number;//游戏失败 开关
    todayTimeEvents?: string[]; // 今日出现的定时事件
    goldGGLSwitch?: number;//黄金刮刮乐开关
    backpack?: normalBackPackSaveMap//背包
    gglNewEggArray ?: number[];//新刮刮乐 天数
    lotteryFuturePrize ?: SsqFuturePrizeCache;//刮刮乐未来结果
    futuresFuturePrize ?: FuturesFuturePrizeCache;//期货未来 结果
    lotteryMachineData?: NormalLotteryMachineI; // 双色球数据
    todayAuctionNum?: number;

    streetInfo?: string[];//街道信息
    lotteryInfo?: LotteryEntity;//彩票信息
    cementMoveSeconds ?: number;//搬水泥 秒数

    todayEventCount?: number,
    ariseLotteryNumbers?: string[];
    stockArray?: NormalStockI[];
    stockPriceArray?: NormalStockPriceI[];
    todayDate?:string;

    batchingBinData?: BatchingBinCacheEntity[];// 农场 孵化仓 缓存
    chickenData?: ChickenCacheEntity[];// 农场 鸡 缓存
    chickenCoop?: ChickenCoop;//鸡舍

    driftBattleData ?: DriftBattleCacheData[];//漂流瓶数据
    delayDriftBattleData ?: DelayDriftBattleCacheData[];
    // driftBattleCountData ?: DriftBattleCountData;//漂流瓶次数 信息
    todayBattleCount ?: number;//今日捞漂流瓶次数
    hasWatchBattleFlag ?: boolean;//观看视频
    accumulationBattleCount ?: number;//累积捞次数

    shellCollectDay ?: number;//贝壳收集的天数
    bankCooperativeData?:number[];
    breedCooperativeData?:number[];
    hasBreedCooperativeData ?: number[];//已经注册的证书
    hasBankCooperativeData?:number[]; //已经注册过的银行业务
    hasShopCooperativeData?:cooperativeShopSaveItem[];//已经注册过的开店业务

    idleNoticeFlag ?: boolean ;//闲置提示 开关
    investPaitendFlag?:boolean;

    phoenixEggFlag ?: boolean;//凤凰蛋
    dragonEggFlag ?: boolean;//恐龙蛋

    chickenCertification ?: number;//鸡舍证明

    /** 当天案件使用次数 */
    todaySettleLawsuitUseCount?: number;
    /** 最后登录日期 */
    lastLoginDayTime?: number;
    /** 基金当日出现过的物资类型 */
    investToDayAriseAry?:string[];
    /** 最后领取漕运单的时间 */
    lastRecvWaterTransport?: number;
    /** 最后刷新案件时间 */
    lastRefreshCaseDate?: number;
    /** 案件列表 [0(案件表索引), 1(案件id)] */
    settleLawsuitList?: string[][];
    /** 延迟时间事件 */
    delayTimeEventList?: DelayTimeEventInfo[];
    /** 固定时间事件 */
    fixedTimeEvent?: FixedTimeEventInfo;
    /**击中武林盟主武器解锁 */
    missGameUnlockWeapons?:string[];
    /** 抓捕选取的武器id */
    arrestSelectWeapon?: string;
    /** 是否学会无相神功 */
    bMeetGongfu1?: boolean;
    /** 任务数据 暂被弃用  */
    taskDataList?: TaskData[];
    /** 任务数据 */
    taskDataMap?: TaskDataMap;

    /** 是否有新任务未查看 */
    bNewTask?: boolean;
    /** 是否有新完成的任务未查看 */
    bNewFinshTask?: boolean;

    /** 当前每天抽奖次数 */
    curLotteryNum?: number[];
    /** 当前摸牌抽奖次数 */
    curTouchCardNum?: number[];
    goldFlowerLotteryNum?: number;
    /** 是否购买了府邸 */
    bBuyMansion?: boolean;
    /** 是否能进入地图 */
    bCanMilitaryMap?: boolean;
    /** 当前好感 */
    curGoodValue?: number;
    /** 上次广告刷新好感度日期 */
    lastAdGoodData?: number;
    /** 上次记录减少好感度日期 */
    lastRecordSubGood?: number;
    /** 女娲石 */
    nvWaStore?: boolean[];
    /** 藏宝图 */
    treasureMap?: boolean[];

    /** 第一次进入当铺 */
    bFirstEnterPawn?: boolean;
    /** 第一次工作 */
    bFirstJob?: boolean;
    /** 第一次购买石头 */
    bFirstBuyStore?: boolean;

    /** 第一次刮888 */
    lottery888Count?: number;
    /** 进入拯救丘比特 */
    saveCupidFlag?:boolean;
    /**  */
    finishCupidLv1Time?:number;
    /** 同意丘比特2 */
    agreeCupidHelp2?:boolean;
    /**  */
    agreeTakeCow?:boolean;
    /** 是否显示超级权限按钮 */
    bShowSuperPowerBtn?:boolean;
    /** 是否显示崆峒镜按钮 */
    bShowKongTongBtn?:boolean;

    /**是否已经成功拯救了华贵妃 */
    saveArcheryFlag?:boolean;

    /** 是否进入过了套牛 */
    isJoinTakeCow?:boolean;
    /** 是否摸牌连胜3次 */
    bTouchCardConWin?: boolean;
    /** 摸牌关卡解锁 */
    touchCardLevelLock?: TouchCardLevelInfo;
    /** 李白好感度 */
    liBaiGoodValue?:number;
    /**已经聊过的聊天id */
    finishChatedIdM?:{};
    /** 是否是第一次完成李白事件 */
    isFirstLiBai?:boolean;
    /** 是否已交付丘比特翅膀 */
    isDeliveryWings?:boolean;
    /** 是否能进入夸贵妃 */
    bEnterBoastGuiFei?: boolean;
    /** 是否完成夸贵妃 */
    bFinishBoastGuiFei?: boolean;
    /** 夸贵妃广告次数 */
    boastGuiFeiAdCount?: number;
    /** 飞鸽记录点 */
    wechatRecordPoint?: string[];
    /** 典当赎回广告次数 */
    pawnRansomAdCount?: PawnRansomAdInfo;
    /** 是否第一次进入押镖玩法 */
    firstDartFlag?:boolean;
    /** 第一次通过押镖玩法 */
    firstPassDartFlag?:boolean
    /** 是否能进入押镖2 */
    bEnterYabiao2?: boolean;
    /** 是否能进入押镖1 */
    bEnterYabiao1?: boolean;
    /** 是否第一次完成押镖1 */
    bFirstFinishYabiao1?: boolean;
    /** 押镖1进入次数 */
    escortGoodsEnterCount?: number[];
    /**套牛玩法已经套中的牛 */
    takeCowAlreadyWave?:number[];

    /** 摸牌连胜次数 */
    touchCardConWin?: number;

    /**考古信息 */
    kaoguData?: kaoguDataType;
    /**油矿信息 */
    oilfieldData?: oilfieldDataType;
    /** 是否开启打劫匪事件 */
    bOpenHitRobEvent?: boolean;
    /** 是否完成打劫匪事件 */
    bFinishHitRobEvent?: boolean;
    /** 是否完成打劫匪 */
    bFinishHitRob?: boolean;
    /** 是否完成救老婆 */
    bFinishHelpWife?: boolean;
    /** 打劫匪广告状态 */
    hitRobAdList?: boolean[];
    /** 补偿奖励是否领取 */
    bCompensateAward1?: boolean;
    /** 是否当铺获得特殊物品1 */
    bGetPawnSpecialGoods1?: boolean;
    /** 是否娶过当铺老板 */
    bMarryPawnBoos?:boolean;

    /** 是否点击了挖井黑影 */
    bTouchOilFieldBlack?: boolean;
    /** 是否生女儿获得随字 */
    bGrilAwardSui?: boolean;
    /** 跳过剧情广告次数 */
    skipPlotAdCount?: number;
    /** 是否已经跳过剧情 */
    bSkipPlot?: boolean;
    /**金花彩票是否已经触发过彩蛋 */
    goldFlowerTriggerPatind?:boolean;
    /**是否是第一次破译暗语 */
    isFirstBreakCode?:boolean;
    /**是否领取过特大喜讯 */
    isFirstOutSize?:boolean
}
    

/**
 * 摸牌关卡
 */
export interface TouchCardLevelInfo {
    [id:number]: boolean;
}

/**
 * 典当赎回广告次数
 */
export interface PawnRansomAdInfo {
    [id:number]: number;
}
/** 任务 */
export interface TaskData {
    /** 任务id */
    id: string; 
    /** 任务状态 */
    taskState: number;
}
/** 任务 */
export interface TaskDataMap {
    [id:string]: TaskData;
}

/** 延迟时间事件 */
export interface DelayTimeEventInfo {
    /** 事件id */
    id: string;
    /** 开始时间 */
    startTime: number;
    /** 延迟时间 */
    delayTime: number;
    /** 是否完成 */
    bFinish: boolean;
}

export interface FixedTimeEventItem {
    /** 事件id */
    id: string;
    /** 开始时间 秒*/
    startTime: number;
    /** 延迟时间 秒*/
    delayTime: number;
}

/** 延迟时间事件组 */
export interface FixedTimeEventInfo {
    /** 事件组 */
    eventArr: FixedTimeEventItem[][];
    /** 第一个事件触发时间 */
    firstTriggerTime: number;
    arrIdx1: number;
    arrIdx2: number;
    /** 下一天事件组 */
    nextEvent: string[];
    /** 是否完成 */
    bFinish: boolean;
}

/**
 * 期货 未来结果
 */
export interface FuturesFuturePrizeCache {
    triggerDay : number;//触发天数
    triggerGoodsId : number;//触发物品id
}

export interface SsqFuturePrizeCache{
    triggerDay : number ;
    prizeNum : string[];
    goldNum : string[];
}

/**
 *
 */
export interface DriftBattleCountData {
    todayBattleCount : number;//今日 捞次数
}

/**
 * 漂流瓶
 */
export interface DelayDriftBattleCacheData extends DriftBattleCacheData{
    actualTriggerDays : number;//触发天数
}

/**
 * 漂流瓶
 */
export interface DriftBattleCacheData {
    eventId : number;//事件id
    weight : number;//对应权重
}

/**
 * 鸡舍
 */
export interface ChickenCoop {
    capacity : number;//容量
    batchingBinCount ?: number;//孵化箱解锁数量
    nestData ?: NestCacheEntity[];//鸡窝数据
}

/**
 * 鸡窝 实体
 */
export interface NestCacheEntity {
    goodsId : number;//物品id
    count : number;//数量
}

/**
 * 孵化仓
 */
export interface BatchingBinCacheEntity  {
    uniqueId : number;//唯一id
    eggId ?: number;//鸡蛋id
    chickenId ?: number;//小鸡id
    startGameHour : number;//开始小时
    startGameMinute : number;//开始分钟
}
/**
 * 鸡
 */
export interface ChickenCacheEntity  {
    uniqueId : number;//唯一id
    chickenId : number;
    bornGameHour : number;//出生小时
    bornGameMinute : number;//出生分钟
    lastLayHour : number;//上次生蛋小时
    lastLayMinute : number;//上次生蛋分钟
}

/**
 * 彩票实体
 */
export interface LotteryEntity{
    gglValidCount : number;//刮刮乐有效次数
    hjGGLValidCount : number;//黄金刮刮乐有效次数
    currGGLPurchaseCount : number;//当天刮刮乐购买次数
    currNewGGLPurchaseCount : number;//新刮刮乐购买次数
    currGJGGLPurchaseCount : number;//
    currSuperGGLPurchaseCount : number;//超级
}

/**
 * 账户Item
 */
export interface AccountItem {
    uniqueId: string;//唯一标识
    title: string;//标题
    desc: string;//描述
    /** 金额配置 */
    paramsArray: string[];
    /** 总费用 */
    totalFee: number;
    /** 需要支付天数 */
    needPayDays: number;
    /** 已经支付天数 */
    hasPayDays: number;
    /** 每天支付金额 */
    everyDayPay: number;
}

/**
 * 聊天事件链
 */
export interface WeChatTriggerTimeLink {
    startDay: number,
    linkId: string | number
}

/**
 * 聊天触发
 */
export interface WeChatTrigger {
    /** 聊天id */
    id: string,
    /** 事件触发后延迟触发聊天 */
    currentDay: number
}

/**
 * 聊天事件链map
 */
export interface WeChatTriggerLink {
    id: string,
    /** 只触发一次 */
    isOnly: boolean,
    /** 根据时间自动触发 */
    autoTriggerDay?: number,
    /** 触发聊天 */
    link: WeChatTrigger[],
    front?:string
}

export interface WeChatTriggerLinkMap {
    [id: string]: WeChatTriggerLink
}

/**
 * 事件Map
 */
export interface normalEvent_NewMap {
    [id: string]: NormalEvent_New;
}

/**
* 事件
*/
export interface NormalEvent_New {
    /** 事件id */
    id: string,
    /** 事件类型 不填则是默认事件 1是小弹窗事件 2是聊天中点击广告之后触发的事件 3是聊天中发送完消息之后触发的事件*/
    type?: string,  
    /** 图片路径 */
    objSp?: string,
    /** 是否强制打开 */
    triggerPro?: number,
    /** 开始天数 */
    startDay?: number,
    /** 开始时间 */
    startTime?: number,
    /** 是否是唯一事件 */
    isOnly?: boolean,
    /** 人物Id */
    peopleId: string,
    /** 事件描述 */
    eventExplain: string,
    /** 事件选项 */
    eventChooses: NormalEventChoose_New[]
}

/**
 * 事件选项
 */
export interface NormalEventChoose_New {
    chooseExplain: string,
    param?: NormalEventChoose_NewParam
}

/**
 * 选项参数
 */
export interface NormalEventChoose_NewParam {
    [id: string]: any;
}

export interface NormalLotteryMachineI {
    //自己选的号码
    meSelectAry: number[],
    //中奖号码
    winAry: number[],
    //金球号码
    goldAry: number[],
    //购买的天数
    buyDay: number,
    //是否是鼓励奖
    isConsolationPrize: boolean,
    //是否是彩蛋1
    isPainted:boolean,

}

/**
 * 背包物品参数
*/
export interface NormalBackpackI {
    /** ID */
    id: number,
    /** 类型 */
    type?: NormalBackpackType[],
    /** 可以进行交互的类型  0 摆摊 1 使用  2 赠送 */
    interactionType?:number[],
    /** 交互的按钮文案文案 */
    interactionName?:string[],
    /** 名字 */
    name: string,
    /** 物品图片 */
    spPath:string,
    /** 进价 */
    buyPrice: number,
    /** 售价 */
    sellPrice?: number,
    /** 物品介绍 */
    details: string,
    /** 物品效果 */
    effect?:string,
    /** 提升镇守率 */
    promoteGarrison?: number,
    /** 好感度 */
    goodValue?: number,
    /** 获得物品后直接兑换成铜币 */
    bInTimeSell?: boolean,
    /** 是否不可卖出、赠送、典当 */
    bNotSellSend?: boolean;
}

export enum NormalBackpackType{
    egg = "蛋",
    stone = "石头",
    goods = "食物",
    clamShell = "蚌壳",
    BLIND_BOX = '盲盒',
    PWAN_OBJ = "典当行",
    NVWA_STORE = '女娲石',
}

/**
 * 背包物品map
 */
export interface normalBackPackM {
    [id:number]:NormalBackpackI;
}

/**
 * 背包存档物品
 */
export interface normalBackPackSaveI{
    backId:number,
    num:number,
    isSell:boolean,
}


/**
 *
 */
export interface normalBackPackSaveMap{
    [id:number]:normalBackPackSaveI;
}

/**
 * 股票价格参数
 */
export interface NormalStockPriceI {
    //ID
    id: number,
    //名字
    name: string,
    //数量
    count: number
    //价格
    price: number
    //浮动百分比
    percentage: number
    //初始价格
    priceInit?: number
    //股票必涨的天数
    order?: number
    //破产重组时间
    bankruptcy?: number
}

/**
 * 玩家拥有的股票
 */
export interface NormalStockI {
    //ID
    id: number,
    //名字
    name: string,
    //数量
    count: number,
    //购入价格
    buyPrice?: number
}

export interface stallData{
    unlockItems:number[]
}
